import React from 'react';

function clampPercent(value) {
  const number = Number.isFinite(value) ? value : 0;
  return Math.max(0, Math.min(100, Math.round(number)));
}

function ProgressBar({ label, percent = 0, detail = '', visible = true }) {
  const safePercent = clampPercent(percent);

  return (
    <div
      style={{
        overflow: 'hidden',
        maxHeight: visible ? '200px' : '0px',
        marginTop: visible ? '0.75rem' : '0',
        marginBottom: visible ? '20px' : '0',
        opacity: visible ? 1 : 0,
        transition: 'max-height 500ms ease, opacity 500ms ease, margin 500ms ease',
        pointerEvents: visible ? 'auto' : 'none'
      }}
    >
      <div
        style={{
          padding: '0.75rem',
          border: '1px solid #d1d5db',
          borderRadius: '8px',
          background: '#f9fafb'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem', marginBottom: '0.4rem' }}>
          <strong>{label}</strong>
          <span style={{ fontVariantNumeric: 'tabular-nums' }}>{safePercent}%</span>
        </div>
        <div
          style={{
            width: '100%',
            height: '10px',
            borderRadius: '9999px',
            background: '#e5e7eb',
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              width: `${safePercent}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #2563eb 0%, #3b82f6 100%)',
              transition: 'width 180ms ease'
            }}
          />
        </div>
        {detail && (
          <div style={{ marginTop: '0.4rem', fontSize: '12px', color: '#4b5563' }}>
            {detail}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProgressBar;